import { colorSet } from '@theme';
import { Pagination as MuiPagination, styled } from '@mui/material';

interface IPaginationProps {
  page: number;
  pageCount: number;
  onChange?: (page: number) => void;
}

const StyledPagination = styled(MuiPagination)(({ theme }) => ({
  backgroundColor: colorSet.gray100,
  borderRadius: 14,
  '& button': {
    margin: 0
  },
  '& .MuiPaginationItem-root': {
    width: 28,
    minWidth: 28,
    height: 28
  },
  '& .MuiPaginationItem-previousNext': {
    backgroundColor: colorSet.gray200
  },
  '& .MuiPaginationItem-icon': {
    width: 20,
    height: 20
  },
  '& .MuiPaginationItem-text': {
    color: colorSet.gray500,
    ...theme.typography.body1
  },
  '& .Mui-selected': {
    backgroundColor: `${colorSet.primaryMain} !important`,
    color: colorSet.white,
    ...theme.typography.body1,
    fontWeight: 'bold'
  }
}));

export const Pagination = (props: IPaginationProps) => {
  const { page, pageCount, onChange } = props;

  return (
    <div>
      <StyledPagination
        page={isNaN(page) ? 1 : page}
        count={pageCount}
        onChange={(_, newPage) => {
          // 두 번째 파라미터로 새로운 페이지 값을 받음
          if (onChange) {
            onChange(newPage);
          }
        }}
      />
    </div>
  );
};
